import { setContext } from '@apollo/client/link/context'

import { getAuthToken, getProjectId } from '../../session/sessionStorage'
import { getSubdomain } from '../../helpers/url'

export const authLink = setContext((_, { headers }) => {
  const token = getAuthToken()
  const workspace = getSubdomain()
  const projectId = getProjectId()
  headers = { ...headers, workspace, ...(projectId ? { projectId } : {}) }

  if (!token) return { headers }

  return {
    headers: {
      ...headers,
      Authorization: token
    }
  }
})
